module.exports = __webpack_public_path__ + "static/hockey-77ed5fb45bed63e7f3cde5d7cdd4f082.jpg";